
import "../styles/Overlay.css";

const Overlay = () => {
    return (
        <div className="overlay_container">
            <h1>Under Development</h1>
        </div>
    )
}

export default Overlay
